import React, { useState, useEffect, useRef } from 'react'
import * as R from 'ramda'
import moment from 'moment'

import { Row, Col, Button, Input, Skeleton } from 'antd'

// import PartyBackArrow from '../components/PartyBackArrow'
import PartyFooterBg from './PartyFooterBg'
import config from '../config'

import cloud2Img from '../assets/images/img_cloud_2.png'
import cloud3Img from '../assets/images/img_cloud_3.png'
import noDataImg from '../assets/images/icon_no_data.png'
import uploadedImg from '../assets/images/icon_update_done.png'
// import rankingSearchImg from '../assets/images/icon_ranking_search_20.png'
import rankingOneImg from '../assets/images/icon_ranking_one.png'
import rankingTwoImg from '../assets/images/icon_ranking_two.png'
import rankingThreeImg from '../assets/images/icon_ranking_three.png'
import rankingAvatarImg from '../assets/images/image_userhead_90@3x.png'
import rankingArrorPreviousImg from '../assets/images/icon-arrow-previous-20@3x.png'
import rankingArrorNextImg from '../assets/images/icon-arrow-next-20@3x.png'
import emptySearchImg from '../assets/images/icon_empty_search.png'

const imgBaseUrl = config.firebase.getImageUrl()

const gameFlagImg = `${imgBaseUrl}/Party%2Fimg_game_flag.png?alt=media`
const bannerBgImg = `${imgBaseUrl}/Party%2Fimg_game_progress_banner_bg.png?alt=media`
const bannerSunImg = `${imgBaseUrl}/Party%2Fimg_game_progress_sun.png?alt=media`
const footerBgImg = `${imgBaseUrl}/Party%2Fimg_party_ranking_bg.png?alt=media`
const rankingBgImg = `${imgBaseUrl}/Party%2Fimg_ranking_bg_375.png?alt=media`
const rankingTitleImg = `${imgBaseUrl}/Party%2Fimg_ranking_personal.png?alt=media`
const footerElementImg = `${imgBaseUrl}/Party%2Fimg_party_footer_element.png?alt=media`

export default function PartyCompetition(props) {
    // const { Search } = Input

    const { partyInfo, records, hasUploaded, leaderboard, userRecord, setUplaodData, pageCurrent, setPageCurrent, handleSyncProfile, synchronizing } = props

    const scrollHeight = document.documentElement.scrollHeight
    const clientHeight = document.documentElement.clientHeight
    const footerBgHeight = R.min(scrollHeight - 307, 1107)

    const [top, setTop] = useState(`${clientHeight}px`)
    const [dataState, setDataState] = useState({
        state: 0,           // 0: no data, 1: has data, 2: uploaded
        list: []
    })
    // const [inputValue, setInputValue] = useState("")
    const [emptyState, setEmptyState] = useState(false)
    const [pagesCount, setPagesCount] = useState(1)

    useEffect(() => {
        setDataState({
            state: R.and(hasUploaded, partyInfo.limitOnce) ? 2 :
                R.isNil(records) ? 0 :
                    records.count > 0 ? 1 : 0,
            list: R.isNil(records) ? [] : records.list.filter(data => data.distance > partyInfo.lbound),
        })
    }, [records, hasUploaded])

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            setTop(`${scrollHeight - footerBgHeight - currentScrollY}px`)
        }

        window.addEventListener("scroll", handleScroll, { passive: true })

        return () => window.removeEventListener("scroll", handleScroll)
    }, [top])

    useEffect(() => {
        setEmptyState(leaderboard.noData)
        setPagesCount(Math.ceil(leaderboard.count / 10))
    }, [leaderboard])

    useEffect(() => {
        window.scroll(0, 1)
    }, [])

    const handleUpload = (rid) => {
        setUplaodData({
            partyId: partyInfo.partyId,
            rid: rid,
        })
    }

    // const handleSearch = (props) => {
    //     console.log(props)
    // }

    const handleReSearch = () => {
        // setInputValue("")
        setEmptyState(!emptyState)
    }

    const getRankingIcon = (rank) => {
        return (
            rank === 1 ? rankingOneImg
                : rank === 2 ? rankingTwoImg
                    : rank === 3 ? rankingThreeImg
                        : ""
        )
    }

    // console.log(userRecord)

    return (
        <div>
            {/* Backgrond */}
            <div className="party-competition-upper-frame">
                <img src={bannerBgImg} className="party-login-bg-img" alt="background" />
            </div>
            <div className="party-competition-upper-frame">
                <img src={bannerSunImg} className="party-login-bg-img" alt="background" />
            </div>

            <img src={cloud2Img} className="party-competition-cloud2-img" alt="cloud" />
            <img src={cloud3Img} className="party-competition-cloud3-img" alt="cloud" />

            <PartyFooterBg top={top} height={footerBgHeight}>{footerBgImg}</PartyFooterBg>

            {/* Back arrow (Void) */}
            {/* <PartyBackArrow /> */}

            {/* Title */}
            <Row type="flex" justify="center" align="middle" className="party-competition-title-frame">
                <img src={gameFlagImg} className="web-img" alt="title" />
                <p className="party-competition-title-font">{partyInfo.title}</p>
            </Row>

            {/* Uoload */}
            <Row type="flex" justify="center" className="party-competition-hint-frame">
                <p className="party-competition-hint-font">以下為你今日上傳的跑步數據</p>
                <p className="party-competition-hint-font">若確定繳交，請點擊「繳交」</p>
                <p className="party-competition-hint-font-red">競賽期間只能繳交一筆數據，若今日的數據已達到您認為的最佳成績，可進行繳交</p>
            </Row>

            <Row type="flex" justify="center" className="party-competition-data-frame">
                <Col span={24}>
                    <p className="party-competition-data-title">今日數據</p>
                </Col>

                {/* Has Data */}
                <Col span={24} className={dataState.state !== 1 ? "web-hidden" : ""} style={{ marginTop: "4px" }}>
                    {dataState.list.map((record, index) => (
                        <Row type="flex" justify="space-between" align="middle" className="party-competition-data-row" key={index}>
                            <Col span={16}>
                                <p className="party-competition-data-font">跑步 {record.distance} km</p>
                            </Col>

                            <Col span={1} className="party-competition-data-btn-frame">
                                <Button className="party-competition-data-btn" onClick={() => handleUpload(record.rid)}>
                                    繳交
                                </Button>
                            </Col>
                        </Row>
                    ))}
                </Col>

                {/* No Data */}
                <Col span={24} className={dataState.state !== 0 ? "web-hidden" : ""} style={{ marginTop: "16px" }}>
                    <Row type="flex" justify="center">
                        <img src={noDataImg} className="party-competition-data-hint-icon" alt="no data" />
                    </Row>

                    <Row type="flex" justify="center">
                        <p className="party-competition-data-hint-font">今日尚無跑步數據</p>
                        <p className="party-competition-data-hint-font">請回到 app 首頁透過水滴上傳</p>
                    </Row>
                </Col>

                {/* Uploaded */}
                <Col span={24} className={dataState.state !== 2 ? "web-hidden" : ""} style={{ marginTop: "16px" }}>
                    <Row type="flex" justify="center">
                        <img src={uploadedImg} className="party-competition-data-hint-icon" alt="uploaded" />
                    </Row>

                    <Row type="flex" justify="center">
                        <p className="party-competition-data-hint-font">已繳交過數據</p>
                        <p className="party-competition-data-hint-font">競賽期間只能繳交一筆合格數據</p>
                    </Row>
                </Col>
            </Row>

            {/* Leaderboard */}
            <Row type="flex" justify="center" className="party-competition-leaderboard-title-frame">
                <img src={rankingBgImg} className="party-competition-leaderboard-title-bg" alt="background" />
                <img src={rankingTitleImg} className="web-img" alt="title" />

                {/* Search */}
                {/* Function pending */}
                {/* 
                <Row type="flex" justify="center" className="party-competition-leaderboard-search-frame">
                    <Search
                        placeholder="搜尋暱稱"
                        enterButton={
                            <div>
                                <img src={rankingSearchImg} className="party-competition-leaderboard-search-btn-icon" alt="search" />
                                <font className="party-competition-leaderboard-search-btn-text">搜尋</font>
                            </div>
                        }
                        className="party-competition-leaderboard-search"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onSearch={value => handleSearch(value)}
                    />
                </Row>
                 */}
            </Row>

            {/* Self Rank */}
            <div className={emptyState ? "web-hidden" : "party-competition-self-ranking-frame"}>
                <Row
                    type="flex"
                    justify="space-between"
                    align="middle"
                >
                    <Col span={16}>
                        <Row type="flex" align="middle">
                            <Col span={1} className={R.and(userRecord.rank >= 1, userRecord.rank <= 3) ? "party-competition-self-ranking-rank-frame" : "web-hidden"}>
                                <img src={getRankingIcon(userRecord.rank)} className="web-img" alt="rank" />
                            </Col>
                            <Col span={1} className={R.or(userRecord.rank < 1, userRecord.rank > 3) ? "party-competition-self-ranking-rank-frame" : "web-hidden"}>
                                <p className="party-competition-self-ranking-rank-text">{userRecord.rank > 0 ? userRecord.rank : "-"}</p>
                            </Col>
                            <Col span={1} className="party-competition-self-ranking-avatar">
                                <img src={userRecord.avatar || rankingAvatarImg} className="party-competition-self-ranking-avatar-img" alt="avatar" />
                            </Col>
                            <Col span={10}>
                                <p className="party-competition-self-ranking-name">{userRecord.name || "FitGames用戶"}</p>
                            </Col>
                        </Row>
                    </Col>

                    <Col span={8}>
                        <Col className="party-competition-self-ranking-record">
                            {userRecord.duration ? moment.utc(userRecord.duration * 1000).format("HH:mm:ss") : moment.utc(0).format("HH:mm:ss")}
                        </Col>


                        {/* <Row type="flex" justify="end" align="middle">
                            <Col className="party-competition-leaderboard-ranking-record">
                                {record.distance || 0}
                            </Col>
                            <Col className="party-competition-leaderboard-ranking-record-sub">
                                {"公里"}
                            </Col>
                        </Row> */}
                    </Col>
                </Row>

                <Row type="flex" justify="center" style={{ marginTop: "16px" }}>
                    <Col>
                        <Button
                            onClick={() => handleSyncProfile()}
                            loading={synchronizing}
                            className="party-competition-self-ranking-sync-btn">
                            同步我的個人資料
                        </Button>
                    </Col>
                </Row>
            </div>

            {/* Ranking */}
            <div className={emptyState ? "web-hidden" : "party-competition-leaderboard-ranking-frame"}>
                {/* record map */}
                <Skeleton loading={leaderboard.isGetting} active avatar shape="circle" paragraph={{ rows: 0 }}>
                    {leaderboard.list.map((record, index) => (
                        <Row
                            type="flex"
                            justify="space-between"
                            align="middle"
                            style={{
                                marginTop: index > 0 ? "30px" : "0",
                            }}
                            key={index}>
                            <Col span={16}>
                                {/* Rank 1~3 */}
                                <Row type="flex" align="middle" className={leaderboard.page === 0 & index <= 2 ? "" : "web-hidden"}>
                                    <Col span={1} className="party-competition-leaderboard-ranking-rank-frame">
                                        <img src={getRankingIcon(index + 1)} className="web-img" alt="rank" />
                                    </Col>
                                    <Col span={1} className="party-competition-leaderboard-ranking-avatar">
                                        <img src={record.avatar || rankingAvatarImg} className="party-competition-leaderboard-ranking-avatar-img" alt="avatar" />
                                    </Col>
                                    <Col span={10}>
                                        <p className="party-competition-leaderboard-ranking-name">{record.name || "FitGames用戶"}</p>
                                    </Col>
                                </Row>

                                {/* Rank 4~N */}
                                <Row type="flex" align="middle" className={leaderboard.page > 0 | index > 2 ? "" : "web-hidden"}>
                                    <Col span={1} className="party-competition-leaderboard-ranking-rank-frame">
                                        <p className="party-competition-leaderboard-ranking-rank-text">{leaderboard.page * 10 + index + 1}</p>
                                    </Col>
                                    <Col span={1} className="party-competition-leaderboard-ranking-avatar-small">
                                        <img src={record.avatar || rankingAvatarImg} className="party-competition-leaderboard-ranking-avatar-img" alt="avatar" />
                                    </Col>
                                    <Col span={10}>
                                        <p className="party-competition-leaderboard-ranking-name">{record.name || "FitGames用戶"}</p>
                                    </Col>
                                </Row>
                            </Col>

                            <Col span={8}>
                                <Row type="flex" justify="end" align="middle">
                                    {/* For duratiion ranking */}
                                    <Col className="party-competition-leaderboard-ranking-record">
                                        {moment.utc(record.duration * 1000).format("HH:mm:ss") || "-"}
                                    </Col>

                                    {/* For distance ranking */}
                                    {/* <Col className="party-competition-leaderboard-ranking-record">
                                    {record.distance || 0}
                                </Col>
                                <Col className="party-competition-leaderboard-ranking-record-sub">
                                    {"公里"}
                                </Col> */}
                                </Row>
                            </Col>

                        </Row>

                    ))}
                </Skeleton>

                <Skeleton loading={leaderboard.isGetting} active avatar shape="circle" paragraph={{ rows: 0 }} />
                <Skeleton loading={leaderboard.isGetting} active avatar shape="circle" paragraph={{ rows: 0 }} />

                <PaginationLeader
                    pageCurrent={pageCurrent}
                    setPageCurrent={setPageCurrent}
                    totalPages={pagesCount}                                 // 多頁測試
                />
            </div>

            {/* Search Empty */}
            <div className={emptyState ? "party-competition-leaderboard-ranking-empty" : "web-hidden"}>
                <Row type="flex" justify="center" align="middle">
                    <Col span={24} className="party-competition-leaderboard-ranking-empty-img">
                        <img src={emptySearchImg} className="web-img" alt="empty" />
                    </Col>

                    <Col span={24}>
                        <p className="party-competition-leaderboard-ranking-empty-font">查無此參賽者</p>
                    </Col>

                    <Col span={24}>
                        <Button
                            className="party-competition-leaderboard-ranking-empty-btn"
                            onClick={() => handleReSearch()}
                        >
                            重新搜尋
                        </Button>
                    </Col>
                </Row>
            </div>

            {/* Footer image */}
            <div className="party-login-footer-image-frame">
                <img src={footerElementImg} className="web-img" alt="footer" />
            </div>

        </div>
    )
}

const PaginationLeader = (props) => {
    const { pageCurrent, setPageCurrent, totalPages, isGetting } = props

    const pageRef = useRef(1)

    const [pages, setPages] = useState([])

    useEffect(() => {
        getPages(pageCurrent)
    }, [totalPages])

    const handleClickPage = (props) => {
        switch (props) {
            case "next":
                if (pageRef.current !== totalPages) {
                    pageRef.current += 1
                }
                break
            case "previous":
                if (pageRef.current !== 1) {
                    pageRef.current -= 1
                }
                break
            default:
                pageRef.current = props;
        }

        getPages(pageRef.current)

        setPageCurrent(pageRef.current)
    }

    const getPages = (props) => {
        let pagesTemp = []
        if (totalPages >= 3) {
            if (props === 1) {
                for (let num = props; num <= props + 2; num++) {
                    pagesTemp.push(num)
                }
            } else if (totalPages - props + 1 >= 3) {
                for (let num = props - 1; num <= props + 1; num++) {
                    pagesTemp.push(num)
                }
            } else {
                for (let num = totalPages - 2; num <= totalPages; num++) {
                    pagesTemp.push(num)
                }
            }
        } else {
            for (let num = 1; num <= totalPages; num++) {
                pagesTemp.push(num)
            }
        }
        setPages(pagesTemp)
    }

    return (
        <div className="pagination-frame">
            <Row type="flex" justify="center" align="middle">
                <Col>
                    <button
                        className={R.and(pageCurrent !== 1, !isNaN(totalPages)) ? "pagination-button" : "web-hidden-arrow"}
                        onClick={() => handleClickPage("previous")}
                    >
                        <img src={rankingArrorPreviousImg} className="pagination-img" alt="Previous" />
                    </button>
                </Col>
                {pages.map((page) => (
                    <Col key={page}>
                        <button
                            className={
                                page === pageCurrent
                                    ? "pagination-button-current"
                                    : "pagination-button"
                            }
                            onClick={() => handleClickPage(page)}
                        >
                            <p
                                className="pagination-button-text"
                                style={page < 10 ? { left: "0.5px" } : { left: "0" }}
                            >
                                {page}
                            </p>
                        </button>
                    </Col>
                ))}
                <Col>
                    <button
                        className={R.and(pageCurrent !== totalPages, !isNaN(totalPages)) ? "pagination-button" : "web-hidden-arrow"}
                        onClick={() => handleClickPage("next")}
                    >
                        <img src={rankingArrorNextImg} className="pagination-img" alt="Next" />
                    </button>
                </Col>
            </Row>
        </div>
    );
};
